export default (state, groupCode) => {
  const countries = state.fullListOfCountries;

  return countries.filter((object) => object.grps.indexOf(groupCode) != -1);
};
